module.exports = __webpack_public_path__ + "img/center front length to hem.cd842f5b.png";